export const LOADING = 'LOADING';
export const FAILED = 'FAILED';
export const GET_POLICY = 'GET_POLICY';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const NO_FOUND = 'NO_FOUND';
